import React, { useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import CallToActionButton from "./CallActionButton";

const isIOSMobile = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /iPhone|iPad|iPod/i.test(userAgent) && window.innerWidth < 1025;
};

const FullScreenVideo = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (!isIOSMobile()) return;

    const playOnTouch = () => {
      const video = videoRef.current;
      if (video && video.paused) {
        video.play().catch(() => {});
      }
      document.body.removeEventListener("touchstart", playOnTouch);
    };

    document.body.addEventListener("touchstart", playOnTouch, { once: true });

    return () => {
      document.body.removeEventListener("touchstart", playOnTouch);
    };
  }, []);

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <video
        ref={videoRef}
        id="bgVideo"
        autoPlay
        muted
        playsInline
        loop
        preload="auto"
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <source src="/home-video-fixed.mp4" type="video/mp4" />
        Seu navegador não suporta vídeos HTML5.
      </video>

      {/* Conteúdo sobreposto */}
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          color: "white",
          textAlign: "center",
          zIndex: 10,
        }}
      >
        <h1>Estética Milena Sindeaux</h1>
        <h3>Descubra sua melhor versão.</h3>
        <CallToActionButton />
      </Box>
    </Box>
  );
};

export default FullScreenVideo;
